import { Translate } from '@chipinside/translate'
import CloseIcon from '@mui/icons-material/Close'
import { IconButton, Stack, styled, Tooltip, Typography } from '@mui/material'
import { ReactNode } from 'react'
export interface DialogHeaderProps {
  content?: ReactNode
  title?: ReactNode
  subtitle?: ReactNode
  prefix?: ReactNode
  suffix?: ReactNode
  dismissable?: boolean
  handleClose?: () => void
}

const DialogHeaderWrapper = styled('div')({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
})

const DialogHeaderContent = styled('div')({
  alignItems: 'center',
  display: 'flex',
  gap: 12,
})

const DialogHeaderText = styled('div')({
  display: 'flex',
  flexDirection: 'column',
})

export function DialogDefaultHeader({
  content,
  dismissable = true,
  handleClose,
  prefix,
  subtitle,
  suffix,
  title,
}: DialogHeaderProps) {
  if (!content && !title && !subtitle && !prefix && !suffix && !dismissable) {
    return null
  }

  if (content) {
    return <DialogHeaderWrapper>{content}</DialogHeaderWrapper>
  }

  return (
    <DialogHeaderWrapper>
      <DialogHeaderContent>
        {prefix}
        <DialogHeaderText>
          {title && <span>{title}</span>}
          {subtitle && (
            <Typography sx={{ color: 'grey.700', fontSize: 14, lineHeight: 'normal' }}>
              {subtitle}
            </Typography>
          )}
        </DialogHeaderText>
      </DialogHeaderContent>
      <Stack sx={{ alignItems: 'center', flexDirection: 'row', gap: 0.5 }}>
        {suffix}
        {dismissable && (
          <Tooltip title={Translate({ messageKey: 'close' })}>
            <IconButton onClick={() => handleClose?.()}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        )}
      </Stack>
    </DialogHeaderWrapper>
  )
}
